import LevelComponent from '@components/level';
import * as React from 'react';

export interface ILevelpageProps {}

export default function Levelpage(props: ILevelpageProps) {
  return <LevelComponent />;
}
